import { AspectRatio, Box, Flex, Heading, Image, Skeleton, Text } from '@chakra-ui/react';
import { useResources } from 'datx-jsonapi-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { queryConferenceHubCounters } from '@/queries/conference-hub-counters';
import { ThinConference } from '@/resources/ThinConference';

interface IPublisherCardProps {
  publisher: ThinConference;
  hubId: string;
}
export const PublisherCard: FC<IPublisherCardProps> = ({ publisher, hubId, ...rest }) => {
  const { t } = useTranslation();

  const { data: counters } = useResources(queryConferenceHubCounters([publisher.id], hubId));
  const thisCounter = counters?.[0];

  const visibleCount = thisCounter?.visibleLibraryEventsCount ?? publisher.visibleLibraryEventsCount;
  const lectureCount = thisCounter?.lecturesCount ?? publisher.lecturesCount;

  return (
    <Flex
      borderColor="gray.200"
      h="full"
      borderWidth="1px"
      bg="white"
      flexDir="column"
      justifyContent="space-between"
      {...rest}
    >
      <AspectRatio maxW="full" ratio={3 / 2}>
        <Image src={publisher.mediumHeaderImageUrl} alt="" fallback={<Skeleton size="full" />} />
      </AspectRatio>
      <Flex flexDir="column" justifyContent="space-between" px="8" py="4" h="full">
        <Box>
          <Heading fontSize="md">{publisher.abbreviation}</Heading>
          <Heading noOfLines={3} mt={2} fontSize="2xl">
            {publisher.name}
          </Heading>
        </Box>
        <Flex alignItems="center" mt={4}>
          <Text>
            <Heading fontSize="xl" as="span" mr="1">
              {visibleCount}
            </Heading>
            {t('common.event_plural')}
          </Text>
          <Text ml="8">
            <Heading fontSize="xl" as="span" mr="1">
              {lectureCount}
            </Heading>
            {t('common.lecture', { count: lectureCount })}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
